/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_SubInputs */

const en_serve_page_sub = /** @type {(inputs: Serve_Page_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps, once. After that you press one button on Bystep and watch the steps get done — on your laptop, with your own Claude or ChatGPT account. No step credits are used.`)
};

const id_serve_page_sub = /** @type {(inputs: Serve_Page_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga langkah, sekali saja. Setelah itu kamu cukup menekan satu tombol di Bystep dan melihat langkah demi langkah dikerjakan — di laptopmu, dengan akun Claude atau ChatGPT milikmu. Jatah langkah tidak terpakai.`)
};

/**
* | output |
* | --- |
* | "Three steps, once. After that you press one button on Bystep and watch the steps get done — on your laptop, with your own Claude or ChatGPT account. No step ..." |
*
* @param {Serve_Page_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_sub = /** @type {((inputs?: Serve_Page_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_sub(inputs)
	return en_serve_page_sub(inputs)
});